import { useAuthStore } from '@/stores/authStore';
import { hasConfirmedGrant } from '@/stores/grants';

/**
 * Whether the current trader may use the org-bot flow. True only when BOTH the
 * org and the trader are bot-enabled — resolved relay-side (GET /api/trader/me
 * → `botAccess`) and threaded onto the session by refreshMe(). Defaults to
 * false on a stale/missing read so the bot UI never leaks before access lands.
 */
export function useBotAccess(): boolean {
  return useAuthStore((s) => hasConfirmedGrant(s.user, 'botAccess'));
}
